import React from 'react';
import Avatar from '../Avatar/Avatar';
import ProfileInfo from '../ProfileInfo/ProfileInfo';
import ProfileStats from '../ProfileStats/ProfileStats';
import './ProfileCard.css';

const ProfileCard = () => {
  return (
    <article className="section profile">
      <div className="line pd">
        <div className="flex flex-jc-c mb-1">
          <Avatar />
        </div>
        <ProfileStats />
      </div>
      <div className="pd">
        <ProfileInfo />
      </div>
    </article>
  );
};

export default ProfileCard;
